module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/koozie-bd18506f3d118c0ba5a7a20533cde213.svg";